import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OfferedRewardRule } from '../../models/rewards-v2.models';
import { ThemeBackgroundPipe } from '../../../shared/pipes/theme-background.pipe';
import {
  formatOfferedRewardTitle,
  formatWonToday,
  getOfferedRewardIllustration,
} from '../../utils/offered-reward.util';

@Component({
  selector: 'app-offered-reward-card',
  standalone: true,
  imports: [CommonModule, ThemeBackgroundPipe],
  templateUrl: './offered-reward-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./offered-reward-card.component.scss'],
})
export class OfferedRewardCardComponent {
  @Input({ required: true }) rule!: OfferedRewardRule;

  get title(): string {
    return formatOfferedRewardTitle(this.rule);
  }

  get wonTodayLabel(): string {
    return formatWonToday(this.rule.amount_won_today);
  }

  get illustrationSrc(): string {
    return getOfferedRewardIllustration(this.rule.service_type);
  }

  get hasProgress(): boolean {
    return this.rule.progress !== null && this.rule.items_sold > 1;
  }

  get progressCurrent(): number {
    return this.rule.progress ?? 0;
  }

  get progressPercent(): number {
    if (!this.hasProgress || this.rule.items_sold <= 0) {
      return 0;
    }
    return Math.min(100, (this.progressCurrent / this.rule.items_sold) * 100);
  }
}
